module.exports = __webpack_public_path__ + "img/adv_stable.9d2639d5.png";